export enum AttendanceType {
  VIRTUAL = 'Virtual',
  SELFPACE = 'Self Pace',
  INCLASS = 'In-Class',
  ELEARNING = 'eLearning',
  MOBILELEARNING = 'Mobile Learning',
  UNKNOWN = 'Unknown',
}
